import React from 'react'
import styles from './Banner.module.scss'
import classNames from 'classnames/bind';

const cx = classNames.bind(styles)

function Banner() {
    return (
        <section className={cx('banner')}>
            <img src='/imgs/printer.png' alt='' className={cx('logo')} />
            <div className={cx('content')}>
                <h1>Printer: Smart Print Documents</h1>
                <h4>
                    An Android application developed by Starnest JSC.<br/>

The application allows users to print documents, photos, Email, Extract text, web pages, and more .
<br/>
Users can also scan paper documents, edit PDFs, extract text using OCR, and print files stored in Google Drive
                </h4>
            </div>
            <div className={cx('actions')}>
                <button>
                    <a href="https://play.google.com/store/apps/details?id=com.printer.starnest">FREE DOWNLOAD</a>
                </button>
                <div className={cx('social')}>
                    <p>Follow Me</p>
                    <div className={cx('social-icons')}>
                        <img src='/imgs/mail/icons/fb.svg' alt="facebook" />
                        <img src='/imgs/mail/icons/insta.svg' alt="instagram" />
                        <img src='/imgs/mail/icons/youtube.svg' alt="youtube" />
                        <img src='/imgs/mail/icons/tiktok.svg' alt="tiktok" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Banner